(() => {
  'use strict';
  if(window.nspirePdpMoneyInstalled)return;
  window.nspirePdpMoneyInstalled=true;
  const selector='main [data-nspire-pilot] product-price .price,main [data-nspire-pilot] product-price .compare-at-price,main [data-nspire-pilot] .nspire-grey-upsell-price,main [data-nspire-pilot] [data-catalog-complement-price],#ea-sticky-cart-root .actualPrice,#ea-sticky-cart-root .easc-comparePrice,#rbr-container-element-addOn [class*="style_price_"] span,#rbr-container-element-addOn [class*="style_price_"] del,#rbr-container-element-addOn [class*="style_price_"] s';
  const region='main [data-nspire-pilot] product-price,main [data-nspire-pilot] .nspire-grey-upsell-price,main [data-nspire-pilot] [data-catalog-complement-price],#ea-sticky-cart-root .easc-priceDiv,#rbr-container-element-addOn [class*="style_price_"]';
  let timer;
  function refresh(){
    timer=undefined;
    const root=document.querySelector('main [data-nspire-pilot]');
    if(!root||(root.dataset.currency||window.Shopify?.currency?.active||'EUR')!=='EUR')return;
    document.querySelectorAll(selector).forEach(e=>{
      if(e.children.length)return;
      if(e.closest('#rbr-container-element-addOn')&&/^\u20ac\s*[\d.]+(?:,(?!00$)\d{2})?$/.test(e.textContent.trim()))return;
      const match=e.textContent.trim().match(/^(?:\u20ac\s*)?([\d.\s]+(?:,\d{2})?)(?:\s*(?:EUR|\u20ac))?$/);
      if(!match)return;
      const text='\u20ac '+match[1].trim().replace(/,00$/,'');
      if(e.textContent!==text)e.textContent=text;
    });
  }
  function schedule(){if(timer===undefined)timer=setTimeout(refresh,80);}
  function boot(){
    refresh();
    new MutationObserver(records=>{
      if(records.some(r=>{
        const p=r.target.nodeType===Node.ELEMENT_NODE?r.target:r.target.parentElement;
        return p?.closest(region)||[...r.addedNodes].some(n=>n.nodeType===Node.ELEMENT_NODE&&(n.matches(region)||n.querySelector(region)));
      }))schedule();
    }).observe(document.body,{childList:true,subtree:true,characterData:true});
    document.addEventListener('variant:update',schedule);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
